export const userManagementBaseUrl = process.env.REACT_APP_USER_MANAGEMENT_BASE_URL

export const dataServiceBaseUrl = process.env.REACT_APP_DATA_SERVICE_BASE_URL

export const webUIBaseUrl = process.env.REACT_APP_WEB_UI_BASE_URL

export const userManagement = {
  loginController: {
    login: "/login",
    logout: "/logout",
  },
  permissionController: {
    getAllPermissions: "/permissions/findAllPermissions",
  },
  roleController: {
    getRoles: "/roles",
    addRole: "/roles",
    findRoleById: "/roles/",
    updateRole: "/roles/",
    deleteRole: "/roles/",
  },
  userController: {
    addUser: "/users",
    findUserById: "/users",
    updateUser: "/users",
    deleteUser: "/users",
    getUsers: "/users",
    forgotPassword: "/users/forgotPassword",
    resetPassword: "/users/resetPassword",
    uploadUsers: "/users/upload",
    findUsername: "/users/username",
    findAllUsers: "/users/getAllUsers"
  },

   packageMasterController : {
    getAllPackagesWithPagination: "/package", 
    getAllPackages: "/package/getAllPackages",                             
    getPackageById: "/package/",                            
    savePackage: "/package/savePackage",
    updatePackageById: "/package/updatePackage/",                         
    deletePackageById: "/package/deletePackage/",                         
    searchPackages: "/package/getAllPackagesWithSearch"
  },
  
  userRoleController: {
    getUserRoleById: "/roles",
    updateUserRole: "/roles/updateUserRole",
    deleteUserRoleById: "/roles/deleteUserRole",
    getAllUserRole: "/roles/findAllUserRole",
    saveUserRole: "/roles",
    findAllUserRole: "/roles/findAllUserRole",
  },
  userGroupController: {
    getUserGroupById: "/userGroup/findUserGroup",
    updateUserGroup: "/userGroup/updateUserGroup",
    deleteUserGroupById: "/userGroup/deleteUserGroup",
    getAllUserGroup: "/userGroup/findAllUserGroup",
    saveUserGroup: "/userGroup/saveUserGroup",
  },
  usersController: {
    getUserById: "/users",
    updateUser: "/users",
    deleteUserById: "/users",
    getAllUser: "/users",
    saveUser: "/users",
    resetPassword: "/users/resetPassword",
    getAllUsersWithSearch: "/users/getAllUsersWithSearch",
    getUserByGroupId: "users/group"
  },
  countryController: {
    getAllCountries: "/country/getAllCountries",
    saveCountry: "/country/saveCountry",
    updateCountry: "/country/updateCountry",
    deleteCountry: "/country/deleteCountry",
    getCountryById: "/country/getCountryById",
    getAllCountriesWithSearch: "/country/getAllCountriesWithSearch",
  },
  cityController: {
    getAllCities: "/city/getAllCities",
  },
  stateController: {
    getState: "/state/getState",
    saveState: "/state/saveState",
    updateState: "/state/updateState",
    deleteState: "/state/deleteState",
    getStateById: "/state/getStateById",
    getAllStates: "/state/getAllStates",
    getAllStatesWithSearch: "/state/getAllStatesWithSearch",
  },
  auditLogController: {
    saveAuditLog: "auditLog/save",
    getAuditLog: "auditLog/find"
  },
  faqsController: {
    getAllFAQs: "/faq",
    saveFAQ: "/faq/saveFAQ",
    updateFAQ: "/faq/updateFAQ",
    deleteFAQ: "/faq/deleteFAQ",
    getFAQById: "/faq",
    getAllFAQsWithSearch: "/faq/getAllFAQsWithSearch",
  },
  sectionMasterController: {
    getAllSectionMaster: "/sectionMaster",
    saveSectionMaster: "/sectionMaster/saveSectionMaster",
    updateSectionMaster: "/sectionMaster/updateSectionMaster",
    deleteSectionMaster: "/sectionMaster/deleteSectionMaster",
    getSectionMasterById: "/sectionMaster",
    getAllSectionMasterWithSearch: "/sectionMaster/getAllSectionMasterWithSearch",
    findAllSectionMaster: "/sectionMaster/findAllSectionMaster"
  },
  documentCategoryController: {
    getAllDocumentCategory: "/documentCategory",
    saveDocumentCategory: "/documentCategory/saveDocumentCategory",
    updateDocumentCategory: "/documentCategory/updateDocumentCategory",
    deleteDocumentCategory: "/documentCategory/deleteDocumentCategory",
    getDocumentCategoryById: "/documentCategory",
    getAllDocumentCategoryWithSearch: "/documentCategory/getAllDocumentCategoryWithSearch",
    findAllDocumentCategory: "/documentCategory/findAllDocumentCategory"
  },
  documentMasterController: {
    getAllDocumentMaster: "/documentMaster",
    saveDocumentMaster: "/documentMaster/saveDocumentMaster",
    updateDocumentMaster: "/documentMaster/updateDocumentMaster",
    deleteDocumentMaster: "/documentMaster/deleteDocumentMaster",
    getDocumentMasterById: "/documentMaster",
    getAllDocumentMasterWithSearch: "/documentMaster/getAllDocumentMasterWithSearch",
    findAllDocumentMaster: "/documentMaster/findAllDocumentMaster"
  },
  createDoucmentController: {
    createDocument: "createDocument/generate",
    getAllDocumentRecords: "createDocument",
    getDocumentRecordById: "createDocument/findDocumentRecordById",
    updateDocumentRecord: "createDocument/updateDocumentRecord",
    deleteDocumentRecord: "/createDocument/deleteDocumentRecord",
    getDocumentRecordWithSearch: "/createDocument/getAllDocumentRecordWithSearch",
  },
 
};

export const dataService = {
  valueChainCategoryController: {
    getAllValueChainCategoryWithPagination: "/valuechaincategories/with-pagination",
    updateValueChainCategory: "/valuechaincategories",
    deleteValueChainCategoryById: "/valuechaincategories",
    getValueChainCategoryById: "/valuechaincategories",
    saveValueChainCategory: "/valuechaincategories",
    getAllValueChainCategoryWithSearch: "/valuechaincategories/getAllWithSearch",
    getAllValueChainCategory: '/valuechaincategories/findAll',
    getValueChainCategoryByAgentMasterId:"/valuechaincategories/by-agent-master",
  },

  valueChainsController: {
    getValueChainsById: "/valuechains",
    updateValueChain: "/valuechains",
    deleteValueChainById: "/valuechains",
    getAllValueChainsWithPagination: "/valuechains/with-pagination",
    saveValueChain: "/valuechains",
    getAllValueChainsWithSearch: "/valuechains/getAllWithSearch",
    getValueChainCategoryCountName: "/valuechains/getCountAndValueChainCategoryName",
    getAllValueChains: "/valuechains/findAll",
  },


  termController: {
    getTermById: "/terms",
    updateTerm: "/terms",
    deleteTermById: "/terms",
    getAllTerm: "/terms/with-pagination",
    saveTerm: "/terms",
    getTermsTermsetIdById: "/terms/termsetid",
    getTermsStringlistTermsetIdById: "/terms/stringlist/termsetid",
    getAllTermWithSearch: "/terms/getAllWithSearch",
    getCountAndTermSetName: "/terms/getCountAndTermSetName",
  },

  termSetController: {
    getTermSetById: "/termsets",
    updateTermSet: "/termsets",
    deleteTermSetById: "/termsets",
    getAllTermSetWithPagination: "/termsets/with-pagination",
    saveTermSet: "/termsets",
    getAllTermSetWithSearch: "/termsets/getAllWithSearch",
    getAllTemsSet: '/termsets/findAll'
  },

  dataPipelineController: {
    getDataPipelineById: "/datapipelines",
    updateDataPipeline: "/datapipelines",
    deleteDataPipelineById: "/datapipelines",
    getAllDataPipelines: "/datapipelines/with-pagination",
    saveDataPipeline: "/datapipelines",
    getAllDataPipelinesWithSearch: "/datapipelines/getAllWithSearch",
    getCountAndPipelineCategoryName: "datapipelines/getCountAndPipelineCategoryName",
  },

  dataPipelineCategoryController: {
    getDataPipelineCategoryById: "/datapipelinecategories",
    updateDataPipelineCategory: "/datapipelinecategories",
    deleteDataPipelineCategoryById: "/datapipelinecategories",
    getAllDataPipelinesCategoriesWithPagination: "/datapipelinecategories/with-pagination",
    saveDataPipelineCategory: "/datapipelinecategories",
    getAllDataPipelinesCategoriesWithSearch: "/datapipelinecategories/getAllWithSearch",
    getAllDataPipelinesCategories: "/datapipelinecategories/findAll",
  },

  valueChainParagraphExtractController: {
    getValueChainParagraphExtractById: "/valuechainparagraphextract",
    updateValueChainParagraphExtract: "/valuechainparagraphextract",
    deleteValueChainParagraphExtractById: "/valuechainparagraphextract",
    getAllValueChainParagraphExtract: "/valuechainparagraphextract",
    saveValueChainParagraphExtract: "/valuechainparagraphextract",
    getAllValueChainParagraphExtractWithPagination:
      "/valuechainparagraphextract/with-pagination",
    getAllValueChainParagraphExtractWithSearch: "/valuechainparagraphextract/getAllWithSearch"
  },

  agentMasterController: {
    getAgentMasterById: "/agentMaster",
    updateAgentMaster: "/agentMaster",
    deleteAgentMasterById: "/agentMaster",
    getAllAgentMasterWithPagination: "/agentMaster/with-pagination",
    saveAgentMaster: "/agentMaster",
    getAllAgentMasterWithSearch: "/agentMaster/getAllWithSearch",
    getAllAgentMaster: "/agentMaster/findAll",
  },

  dataRecordController: {
    getAllDataRecords: "/datarecords",
    updateDataRecord: "/datarecords",
    deleteDataRecordById: "/datarecords",
    getAllDataRecord: "/datarecords",
    saveDataRecord: "/datarecords",
    getDataRecordById: "/datarecords",
    getDataRecordsWithPagination: "/datarecords/with-pagination",
    getAllDataRecordsWithSearch: "/datarecords/getAllWithSearch"
  },

  responsibilityGroupController: {
    getAllResponsibilityGroup: "/responsibilityGroup/allResponsibilityGroup",
  },

  responsibilityCenterController: {
    getAllResponsibilityCenter: "/responsibilityCenter/allResponsibilityCenter"
  },

  companyController: {
    getAllCompanies: "/companies/all"
  },

  industryMasterController: {
    getAllIndustry: "/industry/with-pagination",
    updateIndustry: "/industry/updateIndustry",
    deleteIndustryById: "/industry/deleteIndustry",
    getIndustryById: "/industry/getIndustryById",
    saveIndustry: "/industry/createIndustry",
    getAllIndustryWithSearch: "/industry/getAllWithSearch"
  },

  subIndustryController: {
    findAllSubIndustry: "/subIndustry/findAllSubIndustry",
    getAllSubIndustry: "/subIndustry",
    saveSubIndustry: "/subIndustry/saveSubIndustry",
    updateSubIndustry: "/subIndustry/updateSubIndustry",
    deleteSubIndustry: "/subIndustry/deleteSubIndustry",
    getSubIndustryById: "/subIndustry",
    getAllSubIndustryWithSearch: "/subIndustry/getAllSubIndustryWithSearch"
  }
};

export const webUI = {
  webSearchController: {
    getResultByTerms: "/getResultByTerms",
    searchForCompany: "/searchforcompany",
    getDetailSearch: "/getDetailSearch"
  },
  gdprController: {
    dataPrivacyComplianceTest: "/process/gdpr/data-policy/check",
    aiRegulationComplianceTest: "/process/ai/regulation/check",
    // aiRegulationComplianceTest: "/process/ai/bias/check",
  },
  vulnerabiltyController: {
    codeCyberSecVulAnalysis: "/process/vulnerability/check",
  },
  aiBiasController: {
    codeAiBiasAnalysis: "/process/ai/bias/check",
    codeVulnerability: "/process/ai/vulnerability/check"
  },
  textMatcherController: {
    termComparisonAnalysis: "/process/ai/text-matcher/frequencey",
  },
  codeReviewController: {
    codeReviewReport: "/codeReviewReport",
  },
  pdfContorller: {
    getPdfRecords: "/pdfs/getPdfs",
    downloadPdf: "/pdfs/download-pdf"
  },
  favouriteController: {
    getAllFavourite: "/favourites/with-pagination",
    updateFavourite: "/favourites",
    deleteFavouriteById: "/favourites",
    getFavouriteById: "/favourites",
    saveFavourite: "/favourites",
    getFavouriteByUserId: "/favourites/user"
  },
  libraryCategoryController: {
    getAllLibraryCategories: "/libraryCategories/with-pagination",
    updateLibraryCategory: "/libraryCategories",
    deleteLibraryCategoryById: "/libraryCategories",
    getLibraryCategoryById: "/libraryCategories",
    saveLibraryCategory: "/libraryCategories",
    getAllLibraryCategoriesBySearch: "/libraryCategories/getAllWithSearch",
    findAllLibraryCategories: "/libraryCategories/findAllLibraryCategories",
    findAllGroupedLibraryCategories:"/libraryCategories/findAllGroupedLibraryCategories"

  },
  privateLibraryController: {
    upload: "/privateDharmaLibrary/upload",
    getLibraryById: "/privateDharmaLibrary",
    getLibrarayBySearch :"/privateDharmaLibrary/search",
    getLibraryByCategoryId: "/privateDharmaLibrary",
    downloadPdf: "/privateDharmaLibrary",
    deletePdf: "privateDharmaLibrary",
    logReadingTime: "/privateDharmaLibrary/logReadingTime",
    getAllPdfUsageLogsWithPagination: "/privateDharmaLibrary/pdfLogs/with-pagination",
    deletePdfUsageById: "/privateDharmaLibrary/pdfLogs",
    getAllPdfUsageLogsWithSearch: "/privateDharmaLibrary/getAllWithSearchPdfLogs",
    buyPrivateDharmaLibrary:"privateDharmaLibrary/buy"
  }
};